'use strict';
module.exports = Number.isNaN || function (x) {
	return x !== x;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/number-is-nan/index.js
// module id = Jxue
// module chunks = 0 1 2 3 4 5 6